import { useQuery } from "react-query";
import {
  getDataIvideon,
  GetDealersResponse,
} from "../requests/getDataIvideon";

export default function useGetDataIvideon(
  sort: string,
  count: any,
  page: any,
  switched: boolean,
) {
  return useQuery<GetDealersResponse>({
    queryKey: ["dealerDealers", { sort, count, page }],
    queryFn: () => getDataIvideon(sort, count, page),
    refetchOnWindowFocus: false,
    enabled: switched,
  });
}
